import React, { useState } from "react";
import IconButtonView from "presentational/common/IconButtonView";
import OutfitNoteInputModalView from "presentational/outfitDetail/OutfitNoteInputModalView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const mobileCss = config.css.mobile;
const desktopCss = config.css.desktop;
const fontCss = config.css.fontThickness;

const UPPER_PADDING_OF_MEMO_SECTION = 24;

const MEMO_TEXT_SIZE_FOR_MOBILE = 12;
const MEMO_TEXT_SIZE_FOR_DESKTOP = 14;

const cssXS = {
  noteArea: {
    marginTop:
      UPPER_PADDING_OF_MEMO_SECTION - mobileCss.standardPaddingBetweenContent,
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse"
  },
  noteContentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  memoTextWrapper: {}
};
const cssXL = {
  noteArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse"
  },
  noteContentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    memoTextWrapper: {}
  }
};

const NoteQuestionTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "mobile"
        ? MEMO_TEXT_SIZE_FOR_MOBILE
        : MEMO_TEXT_SIZE_FOR_DESKTOP,
    fontWeight: fontCss.bold
  }
})(Typography);
const NoteAnswerTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "mobile"
        ? MEMO_TEXT_SIZE_FOR_MOBILE
        : MEMO_TEXT_SIZE_FOR_DESKTOP,
    paddingLeft: 10,
    paddingBottom: 6
  }
})(Typography);

OutfitDetailMemoView.propTypes = {
  memoData: PropTypes.object,
  typeOfUser: PropTypes.oneOf(["pending", "owner", "others", "guest"])
    .isRequired,

  onMemoSubmit: PropTypes.func.isRequired
};

function OutfitDetailMemoView(props) {
  const { memoData, typeOfUser, onMemoSubmit } = props;
  const [noteInputModalOpen, setNoteInputModalOpen] = useState(false);

  const { who, where, what, etc } = memoData;

  const deviceType = getDeviceType();
  const css = deviceType === "mobile" ? cssXS : cssXL;

  const handleAddNoteBtnClick = () => {
    setNoteInputModalOpen(true);
  };

  const handleModalClose = () => {
    setNoteInputModalOpen(false);
  };

  if (typeOfUser === "owner") {
    return (
      <div style={css.noteArea}>
        <div>
          <IconButtonView
            type={"addNote"}
            onClick={handleAddNoteBtnClick}
            buttonSize={"small"}
            fontSize={"medium"}
            color={"default"}
          />
        </div>
        <div style={css.noteContentWrapper}>
          {!!who && who.length > 0 && (
            <div>
              <NoteQuestionTypography>
                <TXT name="wordPlaceholder_outfitWho" />
              </NoteQuestionTypography>
              <NoteAnswerTypography>
                <span style={css.memoTextWrapper}>{who}</span>
              </NoteAnswerTypography>
            </div>
          )}
          {!!where && where.length > 0 && (
            <div>
              <NoteQuestionTypography>
                <TXT name="wordPlaceholder_outfitWhere" />
              </NoteQuestionTypography>
              <NoteAnswerTypography>
                <span style={css.memoTextWrapper}>{where}</span>
              </NoteAnswerTypography>
            </div>
          )}
          {!!what && what.length > 0 && (
            <div>
              <NoteQuestionTypography>
                <TXT name="wordPlaceholder_outfitWhat" />
              </NoteQuestionTypography>
              <NoteAnswerTypography>
                <span style={css.memoTextWrapper}>{what}</span>
              </NoteAnswerTypography>
            </div>
          )}
          {!!etc && etc.length > 0 && (
            <div>
              <NoteQuestionTypography>
                <TXT name="wordPlaceholder_outfitEtc" />
              </NoteQuestionTypography>
              <NoteAnswerTypography>
                <span style={css.memoTextWrapper}>{etc}</span>
              </NoteAnswerTypography>
            </div>
          )}
        </div>
        <OutfitNoteInputModalView
          open={noteInputModalOpen}
          onClose={handleModalClose}
          who={who}
          where={where}
          what={what}
          etc={etc}
          onMemoSubmit={onMemoSubmit}
        />
      </div>
    );
  } else {
    return null;
  }
}

export default OutfitDetailMemoView;
